import withLazyLoading from './withLazyLoading';

export const LazyAboutPage = withLazyLoading(() => import('pages/SupportInfoPages/AboutPage'), 'AboutPage');
export const LazyAdsensePage = withLazyLoading(() => import('pages/AdTestPages/AdsensePage'), 'AdsensePage');
export const LazyAlbum = withLazyLoading(() => import('pages/ProfilePage/Album'), 'Album');
export const LazyAlbumList = withLazyLoading(() => import('pages/ProfilePage/AlbumList'), 'AlbumList');
export const LazyAlbumPhotoModal = withLazyLoading(
    () => import('pages/PhotoModalPages/AlbumPhotoModalPage'),
    'AlbumPhotoModalPage',
);
export const LazyAlertsPage = withLazyLoading(() => import('pages/AlertsPage'), 'AlertsPage');
export const LazyBookmarksPage = withLazyLoading(() => import('pages/BookmarksPage'), 'BookmarksPage');
export const LazyEditProfilePage = withLazyLoading(() => import('pages/EditProfilePage'), 'EditProfilePage');
export const LazyEmailVerificationPage = withLazyLoading(
    () => import('pages/EmailVerificationPage'),
    'EmailVerificationPage',
);
export const LazyFriendsPage = withLazyLoading(() => import('pages/FriendsPage'), 'FriendsPage');
export const LazyGroupPage = withLazyLoading(() => import('pages/GroupPage'), 'GroupPage');
export const LazyHomePage = withLazyLoading(() => import('pages/HomePage'), 'HomePage');
export const LazyInterestsModal = withLazyLoading(() => import('components/InterestsModal'), 'InterestsModal');
export const LazyJoinPage = withLazyLoading(() => import('pages/JoinPage'), 'JoinPage');
export const LazyLanguageSelectModal = withLazyLoading(
    () => import('components/LanguageSelectModal'),
    'LanguageSelectModal',
);
export const LazyLoginPage = withLazyLoading(() => import('pages/LoginPage'), 'LoginPage');
export const LazyMessagesPage = withLazyLoading(() => import('pages/MessagesPage'), 'MessagesPage');
export const LazyModListPage = withLazyLoading(() => import('pages/Moderation/ModListPage'), 'ModListPage');
export const LazyModLogPage = withLazyLoading(() => import('pages/Moderation/ModLogPage'), 'ModLogPage');
export const LazyModRecentContentPage = withLazyLoading(
    () => import('pages/Moderation/ModRecentContentPage'),
    'ModRecentContentPage',
);
export const LazyModSettingsPage = withLazyLoading(() => import('pages/Moderation/ModSettingsPage'), 'ModSettingsPage');
export const LazyModUserSearchPage = withLazyLoading(
    () => import('pages/Moderation/ModUserSearchPage'),
    'ModUserSearch',
);
export const LazyOauthCallbackPage = withLazyLoading(() => import('pages/OauthCallbackPage'), 'OauthCallbackPage');
export const LazyOnboardingPage = withLazyLoading(() => import('pages/OnboardingPage'), 'OnboardingPage');
export const LazyPostPhotoModal = withLazyLoading(
    () => import('pages/PhotoModalPages/PostPhotoModalPage'),
    'PostPhotoModalPage',
);
export const LazyPrivacyPage = withLazyLoading(() => import('pages/SupportInfoPages/PrivacyPage'), 'PrivacyPage');
export const LazyModSingleUserPage = withLazyLoading(
    () => import('pages/Moderation/ModSingleUserPage'),
    'ModSingleUserPage',
);
export const LazyModReportsPage = withLazyLoading(() => import('pages/Moderation/ModReportsPage'), 'ModReportsPage');
export const LazyPubstreamPage = withLazyLoading(() => import('pages/AdTestPages/PubstreamPage'), 'PubstreamPage');
export const LazyRecentPhotoModal = withLazyLoading(
    () => import('pages/PhotoModalPages/RecentPhotoModalPage'),
    'RecentPhotoModalPage',
);
export const LazyResetPasswordPage = withLazyLoading(() => import('pages/PasswordResetPage'), 'ResetPasswordPage');
export const LazySearchGroupsPage = withLazyLoading(() => import('pages/SearchGroupsPage'), 'SearchGroupsPage');
export const LazySearchPeoplePage = withLazyLoading(() => import('pages/SearchPeoplePage'), 'SearchPeoplePage');
export const LazySettingsPage = withLazyLoading(() => import('pages/SettingsPage'), 'SettingsPage');
export const LazySinglePostPage = withLazyLoading(() => import('pages/SinglePostPage'), 'SinglePostPage');
export const LazySupportPage = withLazyLoading(() => import('pages/SupportInfoPages/SupportPage'), 'SupportPage');
export const LazyTosPage = withLazyLoading(() => import('pages/SupportInfoPages/TosPage'), 'TosPage');
export const LazyProfilePage = withLazyLoading(() => import('pages/ProfilePage/ProfilePage'), 'UserProfilePage');
export const LazyProfileUsernameRedirect = withLazyLoading(
    () => import('pages/ProfilePage/ProfileUsernameRedirect'),
    'UserProfileRedirectPage',
);
